import { AxiosResponse } from 'axios';

import { get, post, remove } from 'services/api';
import { IProceduresFormData } from 'views/ProceduresView/components/ProceduresForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `/procedures?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('/procedures/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`/procedures/${id}`);

export const save = (data: IProceduresFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append('name', data.name);
  if (data.state) formData.append('state', data.state);
  if (data.files && Object.values(data.files)) {
    Object.values(data.files).forEach((file) => {
      formData.append('files[]', file);
    });
  }
  if (id) formData.append('_method', 'PUT');
  return post(`procedures${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`/procedures/${id}`);

export const softDeleteFile = (id: string, fileId: string): Promise<AxiosResponse> =>
  remove(`procedures/${id}/files/${fileId}`);
